<template>
    <div class="bottom-relation">
        <!--    <div class="common-head">-->
        <!--      <div class="common-line"></div>-->
        <!--      <div class="common-title">{{value.title}}</div>-->
        <!--    </div>-->
        <div class="nano">
            <ul class="nano-content">
                <li v-for="(item, index) in value.content" :key="index">
                    <div class="item-head cursor" @click="change(item)">
                        <span class="title">{{item.title}}</span>
                        <!--            <el-tag size="small" v-if="item.type">{{item.type}}</el-tag>-->
                    </div>
                    <div class="item-bottom">
                        <span class="overflow-hidden-1" v-if="item.source">source: {{item.source}}</span>
                        <span class="time-text overflow-hidden-1">{{item.pulished}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'relationList',
  props: {
    value: Object
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped lang="scss">
    .bottom-relation {
        .common-head {
            height: 64px;
            align-items: center;
            padding: 0 24px;
            border-bottom: 1px dotted #B5B5B5;
        }

        ul {
            /*padding: 0 25px 25px 25px;*/
            padding-left: 0;
        }

        li {
            padding-top: 18px;
        }

        .item-head {
            display: flex;
            align-items: center;

            .title {
                /*white-space: nowrap;*/
                /*overflow: hidden;*/
                /*text-overflow: ellipsis;*/
                position: static !important;
                color: #303133;
                font-size: 16px;
                font-weight: bolder;
            }

            .el-tag {
                margin-left: 22px;
            }
        }

        .item-bottom {
            display: flex;
            align-items: center;
            width: 100%;
            color: #AAAAAA;
            font-size: 14px;
            padding: 9px 0 10px 0;

            span {
                flex: 1;
                text-align: left;
            }
        }

        .nano {
            /*height: calc(100% - 64px) !important;*/
        }
    }

    .cursor {
        cursor: pointer;
    }
</style>
